import { createContext, useContext } from "react";
import { TangoBrand } from "@t3/shared";
import { useCompanyConfigContext } from "@/context/CompanyConfigContext";
import { firestore } from "@/firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { collection, orderBy, query } from "firebase/firestore";

interface GiftCardCatalogContextType {
  catalog: TangoBrand[];
  catalogLoading: boolean;
  catalogError: string | undefined;
}

const GiftCardCatalogContext = createContext<GiftCardCatalogContextType>({
  catalog: [],
  catalogLoading: false,
  catalogError: undefined,
});

export const useGiftCardCatalogContext = () => {
  return useContext(GiftCardCatalogContext);
};

export const GiftCardCatalogProvider = (props: any) => {
  // const [vendors, setVendors] = useState<Vendors | undefined>()
  const { company } = useCompanyConfigContext();

  // Query the brands collection with proper ordering
  const brandsQuery = query(
    collection(firestore, "company", company.id, "catalogs", "tango", "brands"),
    orderBy("defaultSortOrder"),
  );

  const [catalogData, loading, error] = useCollectionData(brandsQuery);

  // const giftCardsEnabled = companyConfig?.features?.giftCards
  // const replaceTangoWithTremendous = companyConfig?.features?.replaceTangoWithTremendous

  const catalog = catalogData as TangoBrand[];

  const contextValue: GiftCardCatalogContextType = {
    catalog,
    catalogLoading: loading,
    catalogError: error?.message,
  };

  return <GiftCardCatalogContext.Provider {...props} value={contextValue} />;
};
